import { Component } from '@angular/core';
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';

@Component({
  selector: 'app-network-fault-management',
  imports: [FeatureHero],
  templateUrl: './network-fault-management.html',
  styleUrl: './network-fault-management.scss',
})
export class NetworkFaultManagement {

}
